import React from 'react'

import Alert from 'components/ui/alert'
import InlineLink from 'components/ui/inline-link'

const InsightsDisabledAlert = (): React.ReactNode => (
  <Alert icon="warning" status="warning">
    Insights lets you view detailed stats about activity on your DISCO. To view,{' '}
    <InlineLink to="/settings/billing">upgrade.</InlineLink>
  </Alert>
)

export default InsightsDisabledAlert
